export default "__VITE_ASSET__mFvcNkG9__"